export const PermissionPath = {
  getConfig: 'app-setting.get-config',
  setSmsLineNumber: 'app-setting.set-sms-line-number',
  setSupporterNumber: 'app-setting.set-supporter-number',
  setNoticeSupporterNumber: 'app-setting.set-notice-supporter-number',
  setCourierPrice: 'app-setting.set-courier-price',
  setMinPrice: 'app_setting.set-min-courier-price',

  setActivePaymentMethods: 'app-setting.set-active-payment-methods',
  setAppName: 'app-setting.set-app-name',
  setAppSupportingNumber: 'app-setting.set-app-supporting-number',
  setInvoiceRepaymentTimeout: 'app-setting.set-invoice-repayment-timeout',
  setAppDiscountcodeStatus: 'app-setting.set-app-discountcode-module-status',
  cashbackSegments: {
    show: 'app-setting.cashback-segments.show',
    update: 'app-setting.cashback-segments.update',
    reset: 'app-setting.cashback-segments.reset',
  },
  advertisement: {
    index: 'advertisement.index',
    store: 'advertisement.store',
    show: 'advertisement.show',
    update: 'advertisement.update',
    destroy: 'advertisement.destroy',
  },
  discountcode: {
    index: 'discountcode.index',
    store: 'discountcode.store',
    show: 'discountcode.show',
    destroy: 'discountcode.destroy',
  },
  qazvinProPlan: {
    index: 'qazvin-pro-plan.index',
    store: 'qazvin-pro-plan.store',
    show: 'qazvin-pro-plan.show',
    update: 'qazvin-pro-plan.update',
    destroy: 'qazvin-pro-plan.destroy',
  },
  qazvinProBenefitPool: {
    index: 'qazvin-pro-benefit-pool.index',
    store: 'qazvin-pro-benefit-pool.store',
    show: 'qazvin-pro-benefit-pool.show',
    update: 'qazvin-pro-benefit-pool.update',
    destroy: 'qazvin-pro-benefit-pool.destroy',
    codes: {
      index: 'qazvin-pro-benefit-pool.codes.index',
      store: 'qazvin-pro-benefit-pool.codes.store',
      update: 'qazvin-pro-benefit-pool.codes.update',
      destroy: 'qazvin-pro-benefit-pool.codes.destroy',
      destroyAll: 'qazvin-pro-benefit-pool.codes.destroy-all',
    },
    claims: {
      index: 'qazvin-pro-benefit-pool.claims.index',
      export: 'qazvin-pro-benefit-pool.claims.export',
    },
  },
  geofence: {
    index: 'geofence.index',
    store: 'geofence.store',
    show: 'geofence.show',
    update: 'geofence.update',
    destroy: 'geofence.destroy',
    updateIsActive: 'geofence.update-is-active',
  },
  invoice: {
    index: 'invoice.index',
    store: 'invoice.store',
    show: 'invoice.show',
    update: 'invoice.update',
    destroy: 'invoice.destroy',
    getListOfRefunds: 'invoice.get-list-of-refunds',
    doRefund: 'invoice.do-refund',
    sendOnDemandSms: 'invoice.send-on-demand-sms',
    cancel: 'invoice.cancel',
    reactive: 'invoice.reactive',
    accept: 'invoice.accept',
    smartCourierSelector: 'invoice.smart-courier-selector',
    requestCourier: 'invoice.request-courier',
    setCourierSendAt: 'invoice.set-send-at',
    responseDelayInvoice: 'invoice.response-delay-invoice',
    markedAsShortageInvoiceResolved: 'invoice.marked-as-shortage-invoice-resolved',
    markedAsCorrectionInvoiceResolved: 'invoice.marked-as-correction-invoice-resolved',
    getCountOfPendingInvoiceTickets: 'invoice.get-count-of-pending-invoice-tickets',
    smsHistory: 'invoice.history-of-invoice-sms',
    changeCourier: 'invoice.change-courier-type-to-express',
     discountCode: 'invoice.create-gift-discountcode',
  },
  page: {
    index: 'page.index',
    store: 'page.store',
    show: 'page.show',
    update: 'page.update',
    destroy: 'page.destroy',
    storeMedias: 'page.store-medias',
  },
  productCategory: {
    index: 'product-category.index',
    store: 'product-category.store',
    show: 'product-category.show',
    update: 'product-category.update',
    destroy: 'product-category.destroy',
  },
  role: {
    index: 'role.index',
    store: 'role.store',
    show: 'role.show',
    update: 'role.update',
    destroy: 'role.destroy',
    getSuggestionPermissions: 'role.get-suggestion-permissions',
  },
  shop: {
    role: {
      index: 'shop.role.index',
      store: 'shop.role.store',
      show: 'shop.role.show',
      update: 'shop.role.update',
      destroy: 'shop.role.destroy',
      getSuggestionPermissions: 'shop.role.get-suggestion-permissions',
    },
    productCategory: {
      index: 'shop.product-category.index',
      store: 'shop.product-category.store',
      show: 'shop.product-category.show',
      update: 'shop.product-category.update',
      destroy: 'shop.product-category.destroy',
      getWage: 'shop.product-category.get-wage',
      setWage: 'shop.product-category.set-wage',
      destroyWage: 'shop.product-category.destroy-wage',
      getDiscount: 'shop.product-category.get-discount',
      setDiscount: 'shop.product-category.set-discount',
      destroyDiscount: 'shop.product-category.destroy-discount',
      clone: 'shop.product-category.clone',
      updateIsActive: 'shop.product-category.update-is-active',
      setViewAsList: 'shop.product-category.set-view-as-list',
    },
    productStock: {
      index: 'shop.product.stock.index',
      store: 'shop.product.stock.store',
      show: 'shop.product.stock.show',
      update: 'shop.product.stock.update',
      destroy: 'shop.product.stock.destroy',
      setZeroToday: 'shop.product.stock.set-zero-today-remaining',
      increaseToday: 'shop.product.stock.increase-today-remaining',
    },

    index: 'shop.index',
    store: 'shop.store',
    show: 'shop.show',
    update: 'shop.update',
    sendSms: 'shop.send-on-demand-sms',

    destroy: 'shop.destroy',
    address: {
      index: 'shop.address.index',
      store: 'shop.address.store',
      show: 'shop.address.show',
      update: 'shop.address.update',
      destroy: 'shop.address.destroy',
      accept: 'shop.invoice.accept',
    },
    userBlock: {
      index: 'shop.user.block.index',
      store: 'shop.user.block.store',
      destroy: 'shop.user.block.destroy',
    },

    invoice: {
      index: 'shop.invoice.index',
      store: 'shop.invoice.store',
      show: 'shop.invoice.show',
      update: 'shop.invoice.update',
      destroy: 'shop.invoice.destroy',
      topInvoiceitems: 'shop.invoice.top-invoiceitems',
    },
    geofence: {
      index: 'shop.geofence.index',
      store: 'shop.geofence.store',
      show: 'shop.geofence.show',
      update: 'shop.geofence.update',
      destroy: 'shop.geofence.destroy',
      clone: 'shop.geofence.clone',
      status: 'shop-settings.geofence-status',
      batchUpdate: 'shop.geofence.batch-update',
    },
    user: {
      index: 'shop.user.index',
      store: 'shop.user.store',
      show: 'shop.user.show',
      update: 'shop.user.update',
      destroy: 'shop.user.destroy',
      syncRoles: 'shop.user.sync-roles',
    },
    media: {
      index: 'shop.media.index',
      store: 'shop.media.store',
      update: 'shop.media.update',
    },
    callNumber: {
      index: 'shop.call-number.index',
      store: 'shop.call-number.store',
      show: 'shop.call-number.show',
      update: 'shop.call-number.update',
      destroy: 'shop.call-number.destroy',
    },
    comment: {
      index: 'shop.comment.index',
      store: 'shop.comment.store',
      replyShop: 'shop.comment.reply-shop',
    },

    product: {
      index: 'shop.product.index',
      store: 'shop.product.store',
      show: 'shop.product.show',
      update: 'shop.product.update',
      updateChefRecommendation: 'shop.product.update-chef-recommendation',
      destroy: 'shop.product.destroy',
      updateVisibleStatusProduct: 'shop.product.update-visible-status',
      comment: {
        index: 'shop.product.comment.index',
        store: 'shop.product.comment.store',
      },
      getWage: 'shop.product.get-wage',
      setWage: 'shop.product.set-wage',
      destroyWage: 'shop.product.destroy-wage',
      getDiscount: 'shop.product.get-discount',
      setDiscount: 'shop.product.set-discount',
      destroyDiscount: 'shop.product.destroy-discount',
      productCategory: {
        changeCategory: 'shop.product.product-category.change-category',
      },
    },
    workingHour: {
      index: 'shop.working-hour.index',
      store: 'shop.working-hour.store',
      show: 'shop.working-hour.show',
      update: 'shop.working-hour.update',
      destroy: 'shop.working-hour.destroy',
    },
    saleHour: {
      index: 'shop.product.sale-hour.index',
      store: 'shop.product.sale-hour.store',
      show: 'shop.product.sale-hour.show',
      update: 'shop.product.sale-hour.update',
      destroy: 'shop.product.sale-hour.destroy',
    },

    holiday: {
      index: 'shop.holiday.index',
      store: 'shop.holiday.store',
      show: 'shop.holiday.show',
      update: 'shop.holiday.update',
      destroy: 'shop.holiday.destroy',
    },
    getWage: 'shop.get-wage',
    setWage: 'shop.set-wage',
    destroyWage: 'shop.destroy-wage',
    getDiscount: 'shop.get-discount',
    setDiscount: 'shop.set-discount',
    destroyDiscount: 'shop.destroy-discount',
    getAllDiscountcodesForShop: 'shop.get-all-discountcodes-for-shop',
    updatePricePerKm: 'shop.update-price-per-km',
    productCategories: {
      rePrioritize: 'shop.product-categories.re-prioritize',
    },
    products: {
      rePrioritize: 'shop.products.re-prioritize',
    },
    manualTransaction: 'transaction.manual-transaction',
    showTransactionsOfRialsWallet: 'shop.show-transactions-of-rials-wallet',
    search: 'shop.search',
    bankAccount: {
      index: 'shop.bank-account.index',
      store: 'shop.bank-account.store',
      show: 'shop.bank-account.show',
      getUsersBankAccounts: 'shop.bank-account.get-users-bank-accounts',
    },
    liteIndex: 'shop.lite-index',
  },
  shopCategory: {
    index: 'shop-category.index',
    store: 'shop-category.store',
    show: 'shop-category.show',
    update: 'shop-category.update',
    destroy: 'shop-category.destroy',
  },
  shopCategoryHighlight: {
    index: 'highlight-product-category.index',
    store: 'highlight-product-category.store',
    show: 'highlight-product-category.show',
    update: 'highlight-product-category.update',
    destroy: 'highlight-product-category.destroy',
  },
  link: {
    destroy: 'link.destroy',
  },
  media: {
    destroy: 'media.destroy',
  },
  user: {
    index: 'user.index',
    show: 'user.show',
    showTransactionsOfWallet: 'user.show-transactions-of-wallet',
    increaseCreditInPanel: 'user.increase-credit-in-panel',
    decreaseCreditInPanel: 'user.decrease-credit-in-panel',
    block: 'user.block',
    unblock: 'user.unblock',
    assignRole: 'user.assign-role',
    revokeRole: 'user.revoke-role',
    search: 'user.search',
    getOperators: 'user.get-operators',
    markBnplCandidatesInPanel: 'user.mark-bnpl-candidates-in-panel',
    deleteBnplCandidatesInPanel: 'user.delete-bnpl-candidates-in-panel',
  },
  prices: {
    acceptPriceCourierPerKmForShop: 'prices.accept-price-courier-per-km-for-shop',
    rejectPriceCourierPerKmForShop: 'prices.reject-price-courier-per-km-for-shop',
  },
  geocoding: 'geocoding',
  shopSettings: {
    logo: 'shop-settings.logo',
    header: 'shop-settings.header',
    shopCategories: 'shop-settings.shop-categories',
    mealTags: 'shop-settings.meal-tags',
    callNumbers: 'shop-settings.call-numbers',
    getNoticeCallNumbers: 'shop-settings.get-notice-call-numbers',
    noticeCallNumbers: 'shop-settings.notice-call-numbers',
    getCheckoutCallNumbers: 'shop-settings.get-checkout-call-numbers',
    checkoutCallNumbers: 'shop-settings.checkout-call-numbers',
    geofenceStatus: 'shop-settings.geofence-status',
    paymentMethods: 'shop-settings.payment-methods',
    getUsersCallNumbers: 'shop-settings.get-users-call-numbers',
    changeStatus: 'shop-settings.change-status',
  },
  settlement: {
    index: 'settlement.index',
    update: 'settlement.update',
    show: 'settlement.show',
    changeToSettled: 'settlement.change-to-settled',
    sendSms: 'settlement.send-sms',
    createSettlementForShops: 'settlement.create-settlement-for-shops',
    createSettlementForCouriers: 'settlement.create-settlement-for-couriers',
  },
  settlement_accumulative: {
    index: 'settlement-accumulative.index',
    update: 'settlement-accumulative.update',
    show: 'settlement-accumulative.show',
    changeToSettled: 'settlement-accumulative.change-to-settled',
    sendSms: 'settlement-accumulative.send-sms',
    createSettlementForShops: 'settlement-accumulative.create-settlement-for-shops',
    createSettlementForCouriers: 'settlement-accumulative.create-settlement-for-couriers',
  },
  transaction: {
    index: 'transaction.index',
    taxReport: 'transaction.tax-report',
  },
  courier: {
    index: 'courier.index',
    store: 'courier.store',
    show: 'courier.show',
    update: 'courier.update',
    destroy: 'courier.destroy',
    user: {
      index: 'courier.user.index',
      store: 'courier.user.store',
      show: 'courier.user.show',
      update: 'courier.user.update',
      destroy: 'courier.user.destroy',
      addUserAsEmployee: 'courier.user.add-user-as-employee',
      deleteUserAsEmployee: 'courier.user.delete-user-as-employee',
    },
    address: {
      index: 'courier.address.index',
      store: 'courier.address.store',
      show: 'courier.address.show',
    },
    bankAccount: {
      index: 'courier.bank-account.index',
      store: 'courier.bank-account.store',
      show: 'courier.bank-account.show',
      getUsersBankAccounts: 'courier.bank-account.get-users-bank-accounts',
    },
    liteIndex: 'courier.lite-index',
    getPrice: 'courier.get-price',
    setPrice: 'courier.set-price',
    getNoticeCallNumbers: 'courier.get-notice-call-numbers',
    noticeCallNumbers: 'courier.notice-call-numbers',
    getCheckoutCallNumbers: 'courier.get-checkout-call-numbers',
    checkoutCallNumbers: 'courier.checkout-call-numbers',
    showTransactionsOfRialsWallet: 'courier.show-transactions-of-rials-wallet',
    getUsersCallNumbers: 'courier.get-users-call-numbers',
    search: 'courier.search',
  },
  price: {
    index: 'price.index',
    store: 'price.store',
    show: 'price.show',
    update: 'price.update',
    destroy: 'price.destroy',
  },
  expressCourier: {
    liteIndex: 'express-courier.lite-index',
    getPrice: 'express-courier.get-price',
    setPrice: 'express-courier.set-price',
    getNoticeCallNumbers: 'express-courier.get-notice-call-numbers',
    noticeCallNumbers: 'express-courier.notice-call-numbers',
    getCheckoutCallNumbers: 'express-courier.get-checkout-call-numbers',
    checkoutCallNumbers: 'express-courier.checkout-call-numbers',
    showTransactionsOfRialsWallet: 'express-courier.show-transactions-of-rials-wallet',
    getUsersCallNumbers: 'express-courier.get-users-call-numbers',
    user: {
      addUserAsEmployee: 'express-courier.user.add-user-as-employee',
      deleteUserAsEmployee: 'express-courier.user.delete-user-as-employee',
    },
    bankAccount: {
      getUsersBankAccounts: 'express-courier.bank-account.get-users-bank-accounts',
    },
    search: 'express-courier.search',
  },
  attribute: {
    discountRequest: {
      qasedak_share: 'attribute.discount-request.qasedak-share',
    },
    shopUpdateRequest: {
      status: 'attribute.shop-update-request.status',
    },
  },
  delayInvoice: {
    index: 'delay-invoice.index',
  },
  shortageInvoice: {
    index: 'shortage-invoice.index',
  },
  correctionInvoice: {
    index: 'correction-invoice.index',
  },

  walletPayment: {
    index: 'wallet-payment.index',
  },

  comment: {
    index: 'comment.index',
    store: 'comment.store',
    show: 'comment.show',
    update: 'comment.update',
    destroy: 'comment.destroy',
    changeToReviewedBySupport: 'comment.change-to-reviewed-by-support',
    replySupport: 'comment.reply-support',
  },
  requestCourier: {
    index: 'invoice.request-courier',
  },
  ActivityReport: {
    index: 'activity.index',
  },
  CreditService: {
    index: 'bnpl-agreement.index',
  },
  Reports:{
    index:'report.shops-without-visible-products',
    reportHighCancellationShops:'report.high-cancellation-shops',
    reportShopsWithoutVisibleProducts:'report.shops-without-visible-products'
  },
  Messenger:{
    index:'messenger.send-to-long-running-shops'
  }
};
